import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MainLayoutComponent } from './layouts/main-layout/main-layout.component';
import { EncuestaPageComponent } from './pages/encuesta-page/encuesta-page.component';
import { CompletePageComponent } from './pages/complete-page/complete-page.component';

const routes: Routes = [
  {
    path: '',
    component: MainLayoutComponent,
    children: [
      {
        path: 'encuestas/:idEncuestaCliente',
        component: EncuestaPageComponent
      },
      {
        path: 'complete',
        component: CompletePageComponent
      }
    ] 
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
